const e=e=>Boolean(e.isRefined);export{e as isFilterRefined};
